import type { Novidade } from './tipos';

/** Fase 2 (W21, K7): arremates do Início (Novidades, baixa rápida, previsto no fluxo, ações rápidas e índices agora). */
export const novidadeInicioArremates: Novidade = {
  id: '2026-10-05-inicio-arremates',
  publicada_em: '2026-10-05',
  tipo: 'melhoria',
  modulo: null,
  permissao: null,
  textos: {
    pt: {
      titulo: 'Início com novidades, baixa rápida e o saldo previsto',
      resumo: 'O Início ganhou o card Novidades, a baixa nos próximos vencimentos, o saldo previsto no fluxo de caixa e novas ações rápidas.',
      passos: [
        'Na seção Sistema, o card Novidades mostra o que você ainda não viu; clique numa novidade para abrir o passo a passo e a aula.',
        'Em Próximos vencimentos, o botão Baixar abre a mesma baixa do Contas, com juros e multa calculados na data.',
        'O Fluxo de caixa mostra, tracejado, o saldo previsto com as faturas e contas a pagar em aberto, pelo vencimento.',
        'As ações rápidas trazem Novo contrato e Nova tarefa, e quem administra o sistema pode atualizar os índices na hora.',
      ],
    },
    en: {
      titulo: 'Home with updates, quick settlement and the expected balance',
      resumo: 'Home now has the Updates card, settlement in upcoming due dates, the expected balance in the cash flow and new quick actions.',
      passos: [
        "In the System section, the Updates card shows what you haven't seen yet; click one to open the steps and the lesson.",
        'In Upcoming due dates, the Settle button opens the same settlement as Receivables and payables, with interest and fee on the date.',
        'The Cash flow shows, dashed, the expected balance with open invoices and bills, by due date.',
        'Quick actions now include New contract and New task, and administrators can update the indices right away.',
      ],
    },
    es: {
      titulo: 'Inicio con novedades, baja rápida y el saldo previsto',
      resumo: 'El Inicio ganó la tarjeta Novedades, la baja en los próximos vencimientos, el saldo previsto en el flujo de caja y nuevas acciones rápidas.',
      passos: [
        'En la sección Sistema, la tarjeta Novedades muestra lo que aún no viste; haz clic en una para abrir el paso a paso y la clase.',
        'En Próximos vencimientos, el botón Dar de baja abre la misma baja de Cuentas, con intereses y multa calculados en la fecha.',
        'El Flujo de caja muestra, punteado, el saldo previsto con las facturas y cuentas por pagar abiertas, por vencimiento.',
        'Las acciones rápidas traen Nuevo contrato y Nueva tarea, y quien administra el sistema puede actualizar los índices al momento.',
      ],
    },
  },
  imagens: ['/novidades/2026-10-05-inicio-arremates/inicio.webp', '/novidades/2026-10-05-inicio-arremates/baixa.webp', null, null],
  treinamento: { curso: 'novidades' },
  rota: '/',
};
